import styles from './Loading.module.scss'
const Loading = () => <span className={styles.loader} />
export default Loading
